import React, { ReactElement, useState } from 'react'
import { ContainerTabela } from '@pages/style'
import { Button, List, Popconfirm } from 'antd'
import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons'
import HeaderPage from '@components/atoms/HeaderPage'
import { useFetch, useRouter } from '@customHooks'
import { IStatusChamado } from '@app'
import api from '@services/api'

export default function Status(): ReactElement {
  const { navigate } = useRouter()
  const [reload, setReload] = useState(false)

  const { apiData: status, isLoading } = useFetch<IStatusChamado>({
    url: 'statuschamado',
    reload,
  })

  const onDelete = async (id: number) => {
    await api.delete(`statuschamado/${id}`).finally(() => setReload(!reload))
  }

  return (
    <ContainerTabela>
      <HeaderPage
        title='Status Chamado'
        extra={[
          <Button
            key='insert'
            icon={<PlusOutlined />}
            size='large'
            type='primary'
            onClick={() => navigate('novo')}
          >
            Novo Status
          </Button>,
        ]}
      />
      <List
        style={{ backgroundColor: '#FFF' }}
        itemLayout='horizontal'
        bordered
        dataSource={status}
        loading={isLoading}
        renderItem={(item) => (
          <List.Item
            actions={[
              <Button
                key='edit'
                onClick={() =>
                  navigate(`${item.ID_STATUSCHAMADO}`, {
                    state: item,
                  })
                }
                type='link'
                icon={<EditOutlined />}
              >
                Editar
              </Button>,
              <Popconfirm
                key='delete'
                title='Deseja realmente excluir este registro?'
                onConfirm={() => onDelete(item.ID_STATUSCHAMADO)}
              >
                <Button type='text' icon={<DeleteOutlined />}>
                  Apagar
                </Button>
              </Popconfirm>,
            ]}
          >
            <List.Item.Meta
              title={item.DESCSTATUS}
              description={`Tempo limite: ${item.TEMPO_RESPOSTA}`}
            />
          </List.Item>
        )}
      />
    </ContainerTabela>
  )
}
